import { render, staticRenderFns } from "./RectifyTrends.vue?vue&type=template&id=941b495e&scoped=true"
import script from "./RectifyTrends.vue?vue&type=script&lang=js"
export * from "./RectifyTrends.vue?vue&type=script&lang=js"
import style0 from "./RectifyTrends.vue?vue&type=style&index=0&id=941b495e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941b495e",
  null
  
)

export default component.exports